var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgShoppingCartBasket = function SvgShoppingCartBasket(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 102,
    viewBox: "0 0 120 102",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3 30.1819V21.7819C41.3 13.3819 48 6.48193 56.5 6.48193C64.8 6.48193 71.7 13.2819 71.7 21.7819V30.1819",
    stroke: "#C7D2DD",
    strokeWidth: 1.8941,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3 92.5819C93.7 92.3819 93.8 92.1819 94.2 92.0819",
    stroke: "#FF78B7",
    strokeWidth: 0.6123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 100.582H118.1",
    stroke: "#B1B9CC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 100.582H5.4",
    stroke: "#B1B9CC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.9 14.282H15.7V99.682H100.9V14.282Z",
    fill: "#FEFEFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.1 14.282H39.4V99.682H101V14.282H101.1Z",
    fill: "#E6ECF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 14.282H15.7V99.682H27.5V14.282Z",
    fill: "url(#paint0_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4 99.6819H15.7V99.4819L27.7 87.5819L39.4 99.6819Z",
    fill: "#E6ECF5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3 33.2819C56 33.2819 57.4 31.8819 57.4 30.1819C57.4 28.4819 56 27.0819 54.3 27.0819C52.6 27.0819 51.2 28.4819 51.2 30.1819C51.2 31.8819 52.6 33.2819 54.3 33.2819Z",
    fill: "#C7D2DD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7 33.2819C86.4 33.2819 87.8 31.8819 87.8 30.1819C87.8 28.4819 86.4 27.0819 84.7 27.0819C83 27.0819 81.6 28.4819 81.6 30.1819C81.7 31.8819 83 33.2819 84.7 33.2819Z",
    fill: "#C7D2DD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3 30.1819V21.7819C54.3 13.3819 61 6.48193 69.5 6.48193C77.8 6.48193 84.7 13.2819 84.7 21.7819V30.1819",
    stroke: "#C7D2DD",
    strokeWidth: 1.8941,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3939 3.04158C96.5534 1.65729 99.1005 0.88208 101.814 0.88208C109.234 0.88208 115.269 6.86225 115.269 14.2821C115.269 21.7019 109.234 27.6821 101.814 27.6821C94.3939 27.6821 88.3584 21.7019 88.3584 14.2821C88.2476 9.57547 90.684 5.47795 94.3939 3.04158Z",
    fill: "url(#paint1_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.812 20.282C99.1092 20.282 96.8119 17.855 96.8119 14.2146C96.8119 10.5741 99.1092 8.28198 101.812 8.28198C104.515 8.28198 106.812 10.5741 106.812 14.2146C106.812 17.855 104.515 20.282 101.812 20.282ZM101.812 17.4505C102.758 17.4505 103.704 16.5067 103.704 14.2146C103.839 12.0573 102.758 10.9786 101.812 10.9786C100.866 10.9786 99.92 12.0573 99.92 14.2146C99.92 16.5067 100.866 17.4505 101.812 17.4505Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8759 57.5815C56.4408 57.5815 53.5553 55.3837 52.4561 52.2244C52.1813 51.5376 52.5935 50.8508 53.2805 50.576C53.9675 50.3013 54.6545 50.7134 54.9294 51.4002C55.6164 53.4607 57.6774 54.9716 59.8759 54.9716C62.0744 54.9716 64.1355 53.598 64.8225 51.4002C65.0973 50.7134 65.7843 50.3013 66.4713 50.576C67.1584 50.8508 67.5706 51.5376 67.2958 52.2244C66.1965 55.5211 63.311 57.5815 59.8759 57.5815Z",
    fill: "#ADB6C8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6241 57.5815C77.189 57.5815 74.3035 55.3837 73.2042 52.2244C72.9294 51.5376 73.3416 50.8508 74.0287 50.576C74.7157 50.3013 75.4027 50.7134 75.6775 51.4002C76.3645 53.4607 78.4256 54.9716 80.6241 54.9716C82.8226 54.9716 84.8836 53.598 85.5707 51.4002C85.8455 50.7134 86.5325 50.3013 87.2195 50.576C87.9065 50.8508 88.3187 51.5376 88.0439 52.2244C86.9447 55.5211 84.0592 57.5815 80.6241 57.5815Z",
    fill: "#ADB6C8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3188 74.4002C72.0641 74.4002 73.4791 72.9857 73.4791 71.2409C73.4791 69.496 72.0641 68.0815 70.3188 68.0815C68.5734 68.0815 67.1584 69.496 67.1584 71.2409C67.1584 72.9857 68.5734 74.4002 70.3188 74.4002Z",
    fill: "#ADB6C8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 21.5739,
    y1: 16.5548,
    x2: 21.5739,
    y2: 98.4531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#E6ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED7E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 101.814,
    y1: 1.81308,
    x2: 101.814,
    y2: 16.8557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShoppingCartBasket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopping-cart-basket.5b46e376.svg";
export { ForwardRef as ReactComponent };